String.prototype.trimLeft = function (value) {
    if (value === undefined)
        value = "\s";

    return this.replace(new RegExp('^[' + value + ']+'), '');
};

String.prototype.upperCase = function () {
    return this.replace('i', 'İ').toUpperCase();
};

window.hexToRgba = function (hex, opacity = 1) {
    return 'rgba(' + parseInt(hex.slice(-6, -4), 16)
        + ',' + parseInt(hex.slice(-4, -2), 16)
        + ',' + parseInt(hex.slice(-2), 16)
        + ',' + opacity + ')';
};
